export enum PageSize {
    A4 = 'a4',
    Letter = 'letter',
    Legal = 'legal'
}

export enum PageOrientation {
    Portrait = 'Portrait',
    Landscape = 'Landscape',
}

export enum ThemeTemplateMode {
    Default = 'Default',
    Word = 'Word',
    Html = 'Html',
}
